import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { setIsRecipientPreviewModalVisible } from 'SelfServeBuilder/SelfServeBuilderActions';
import {
  PrepareToSendIcon,
} from 'DesignSystem/Icons';
import { PrimaryButton } from 'DesignSystem/Buttons';
import * as SectionOrganizerActions from './SectionOrganizerActions';
import Section from './Section';


export const SECTION_ORGANIZER_DROPPABLE_ROOT_LEVEL = 'ROOT';

class SectionOrganizer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onDragEnd = this.onDragEnd.bind(this);
    this.showRecipientPreview = this.showRecipientPreview.bind(this);
  }

  onDragEnd(result) {
    const { source, destination, type } = result;
    if (!destination) {
      return;
    }

    if (this.props.showSample) {
      return;
    }

    if (type === SECTION_ORGANIZER_DROPPABLE_ROOT_LEVEL) {
      this.props.reorderSectionFromSectionOrganizer(
        source.index,
        destination.index,
      );
    } else {
      this.props.moveFieldIdInSectionOrganizer(
        source.droppableId,
        source.index,
        destination.droppableId,
        destination.index,
      );
    }
  }

  showRecipientPreview() {
    window._track('Preview', 'Template Builder');
    this.props.setIsRecipientPreviewModalVisible(true);
  }

  render() {
    const self = this;
    return (
      <React.Fragment>
        <div className="self-serve-post-builder-organization-side-panel">
          <div className="button-container">
            <PrimaryButton
              className="prepare-to-send-button"
              onClick={this.props.displayRecipientManager}
              icon={(<PrepareToSendIcon />)}
            >
              Prepare To Send
            </PrimaryButton>
          </div>

          <div className="description-container">
            <h3 className="description-title">
              Organize Sections
            </h3>
            <p className="description-text">
              Name and add sections.<br />
              Rearrange the order your recipient answers.<br />
              Recipient sees only one section at a time.
            </p>
          </div>

          <div className="organization-section-container">
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable
                droppableId={'section-organizer-outer-droppable'}
                type={SECTION_ORGANIZER_DROPPABLE_ROOT_LEVEL}
              >
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {
                      self.props.sectionIds.map((sectionId, sectionIndex) => {
                        const showTopDroppableArea = snapshot.isDraggingOver;
                        return (
                          <React.Fragment key={sectionId}>
                            {showTopDroppableArea &&
                              <div className="organizer-section-droppable-placeholder" />
                            }
                            <Section
                              canDelete={self.props.sectionIds.length > 1}
                              showSample={sectionIndex === 0 && self.props.showSample}
                              sectionId={sectionId}
                              sectionIndex={sectionIndex}
                            />
                          </React.Fragment>
                        );
                      })
                    }
                    {provided.placeholder}
                  </div>
                  )
                }
              </Droppable>
            </DragDropContext>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SectionOrganizer.defaultProps = {
  sectionIds: [],
  showSample: false,
};

SectionOrganizer.propTypes = {
  displayRecipientManager: PropTypes.func.isRequired,
  moveFieldIdInSectionOrganizer: PropTypes.func.isRequired,
  reorderSectionFromSectionOrganizer: PropTypes.func.isRequired,
  sectionIds: PropTypes.arrayOf(PropTypes.string),
  showSample: PropTypes.bool,
  setIsRecipientPreviewModalVisible: PropTypes.func.isRequired,
};


const mapStateToProps = ({
  AnimationReducer,
  SelfServePostBuilderSidePanelHandler,
}) => ({
  animationHandler: AnimationReducer,
  showSample: SelfServePostBuilderSidePanelHandler.SectionOrganizerReducer.showSample,
  sectionIds: SelfServePostBuilderSidePanelHandler.SectionOrganizerReducer.sections.map(
    section => (section.id),
  ),
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    ...SectionOrganizerActions,
    setIsRecipientPreviewModalVisible,
  }, dispatch)
);

export default ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(SectionOrganizer);



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/SectionOrganizer/index.jsx